import {STATE} from '../../models/state.model';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/free-solid-svg-icons/faSpinner';
import {faCircleCheck} from '@fortawesome/free-regular-svg-icons/faCircleCheck';
import React from 'react';

export const SUBMIT_BUTTON_TEXT = 'Send';

const SubmitButton = ({state}: {state: STATE}) => {
	const classes = 'bg-primary text-white px-4 py-2 rounded-md focus:outline-hidden focus:ring-2 focus:ring-opacity-50';
	switch (state) {
		case STATE.PROCESSING:
			return (
				<button type="submit" disabled={true} className={classes}>
					<FontAwesomeIcon icon={faSpinner} className={'fa-spin mr-2'}/>Sending
				</button>
			);
		case STATE.COMPLETED:
			return (
				<button type="submit" disabled={true} className={classes}>
					<FontAwesomeIcon icon={faCircleCheck} className={'mr-2'}/>Sent
				</button>
			);
		default:
			return (
				<button type="submit" className={classes}>{SUBMIT_BUTTON_TEXT}</button>
			);
	}
};

export default SubmitButton;
